export class AtualizarCompromissoSignature {
  id: string;
  titulo: string;
  descricao: string;
  data_compromisso: Date;
  metadata: string;

  constructor(values: Partial<AtualizarCompromissoSignature> = {}) {
    Object.assign(this, values);
  }
} 